export const AppConfig = {
  apiUrl: 'https://api.form.io',
  //url_backend:'http://localhost:3900/backend',
  // url_backend:'http://18.188.201.174:3900/backend',
  // url_backend:'https://apiformulariosdigitales.bi.com.gt/backend',
  //url_backend: 'https://edge-thomas-delayed-pc.trycloudflare.com/backend',
  url_backend:'https://apiformulariosdigitales.bi.com.gt/backend',
  // url_backend:'http://192.168.100.123:3900/backend',
  // url_backend:'https://formulariosapi.niu.marketing/backend',
  hapikey:'2d5e2a0f-7daf-4ed6-99dd-2282c915d511',
  url_backendFacephi: 'https://backendfacephi.niu.marketing',
  data_properties: '',
  CredoLab : {
    authKey: "74fd0097-e53e-4784-90af-703252dc0ff2",
    //authKey: "5dd10aaf-6522-4fa3-a787-4336b6b965b8",    
    url: "https://scoring-br.credolab.com",
    //url: "https://scoring-br.credolab.com",
  }
};

 